import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Row = styled.div<{ $disabled?: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;

export const Box = styled.button<{ $checked: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 22px;
    height: 22px;
    margin-top: 1px;
    padding: 0;
    border: 1px solid ${({ $checked }) => ($checked ? colors.primary : colors.fieldBorder)};
    border-radius: ${radii.small};
    background: ${({ $checked }) => ($checked ? colors.primary : colors.surface)};
    color: ${colors.surface};
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
    outline: none;

    &:disabled {
        cursor: default;
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px ${colors.infoBorder};
    }
`;

export const Text = styled.span<{ $disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    min-width: 0;
    cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
`;

export const LabelText = styled.span`
    font-size: 0.9375rem;
    color: ${colors.textPrimary};
`;

export const Hint = styled.span`
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;
